import React from 'react'
import css from './section.module.css'
import Box from './Box'
import resources from './../../../../resources/index';
const Section2 = () => {
  const boxData = [
    {
      bgColor: '#F8F9FA',
      color: 'green',
      number: '550K+',
      desc: 'Active Users'

    },
    {
      bgColor: 'white',
      color: 'blue',
      number: '250K',
      desc: 'Team Members'

    },
    {
      bgColor: 'white',
      color: 'black',
      number: '$20M+',
      desc: 'Revenue Per/Year'

    },
    {
      bgColor: '#F8F9FA',
      color: 'orange',
      number: '8 Years',
      desc: 'In Business'

    },
    {
      bgColor: '#F8F9FA',
      color: 'red',
      number: '425+',
      desc: 'Clients Worldwide'

    },
    {
      bgColor: 'white',
      color: 'blue',
      number: '855+',
      desc: 'Projects Completed'

    },
  ]

  return (
    <div className={css.section2}>
      <div className={css.left}>
        {boxData.map((box, i)=>{
          return(
            <Box key={i} box = {box}  />
          )
        })}
      </div>
        <img className={css.design_1} src={resources.icons.about_design_1} />
        <img className={css.design_2} src={resources.icons.about_design_2} />

      <div className={css.right}>
        <h5>Our Story</h5>
        <h2>A Great Story Starts with a Friendly Team</h2>
        <p>Globally e-enable principle-centered e-business before dynamic quality vectors cross-media materials before proactive outsourcing leverage other's vertical technology leadership.</p>
        <h6>We Are Awarded By-</h6>
        <div className={css.awards}>
          <img src={resources.icons.about_award_1} alt='About award' />
          <img src={resources.icons.about_award_2} alt='About award' />
        </div>
      </div>
    </div>
  )
}

export default Section2